module.exports = __webpack_public_path__ + "media/images/area/area_chubuM400-d5d731ffa5f887b1f44b7dd5b6a39449.jpg";